import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "left transport tabsUp"
}
const _hoisted_2 = { class: "breadcrumbs" }
const _hoisted_3 = { class: "stationNumber" }
const _hoisted_4 = { class: "stationName" }
const _hoisted_5 = { class: "pathLine" }
const _hoisted_6 = { class: "mainStation" }
const _hoisted_7 = { class: "stationName" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "greenLine" }, null, -1)
const _hoisted_9 = { class: "stationNumber" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "verticalLine" })
], -1)
const _hoisted_11 = { class: "location" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "verticalLine" })
], -1)
const _hoisted_14 = { class: "location" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "lastStation" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "dot" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dotTwo" })
], -1)
const _hoisted_18 = { class: "location" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = {
  key: 0,
  class: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapCustom = _resolveComponent("MapCustom")!
  const _component_SidebarWrapper = _resolveComponent("SidebarWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarWrapper, {
    sidebarComponent: _ctx.sidebarComponent,
    mapComponent: _ctx.mapComponent,
    sidebarLeft: true
  }, {
    default: _withCtx(() => [
      (_ctx.trip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.trip.route.short_name), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.trip.headsign), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.trip.route.short_name), 1)
                ]),
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.firstStop.stop.name), 1)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.middleStops, (stop) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "midStation",
                  key: stop.id
                }, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(stop.stop.name), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.lastStop.stop.name), 1)
                ])
              ])
            ]),
            (_ctx.markers !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_MapCustom, {
                    center: _ctx.markers[0].position,
                    markers: _ctx.markers
                  }, null, 8, ["center", "markers"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["sidebarComponent", "mapComponent"]))
}